<template>
  <div class="px-3 md:px-0">
    <h1 class="text-lg font-bold">Prácticas</h1>
    <div class="text-neutral-700 mt-5 space-y-4">
      <p>
        El propósito principal de estas prácticas es brindarte la oportunidad de
        practicar y fortalecer tu comprensión en geometría.
      </p>
      <p>
        La práctica también cuenta con una píldora,
        <span
          ><Icon
            icon="cil:lightbulb"
            inline
            class="inline text-blue-500 bg-blue-50"
        /></span>
        que podrás usar cuando necesites una pequeña ayuda en alguno de los
        ejercicios.
      </p>
    </div>

    <MobList :items="items" class="mt-5" />
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import { MobList } from "@/views/V2/components";
import { enrollToCourse } from "@/services/courses.service";
import {getStudentStatusPractice} from "@/services/practices.service";


export default {
  name: "PracticeIntro",
  components: {
    MobList,
    Icon,
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    course() {
      return this.$store.state.course.current;
    },
  },
  watch: {
    course: {
      immediate: true,  // dispara también al montar
      async handler(newCourse) {
        if (newCourse.id == null) return;
        
        let courseId = this.$route.params.id;
        if (courseId) {
          let practices = await getStudentStatusPractice(courseId);

          for (const element of practices) {
            let currentState = '';
            let  link = element.id.toString();

            if (!this.course.enrolled) {
              currentState = 'disabled';
              link = `/course/${courseId}/practices`;
            } else if (element.finished) {
              currentState = 'completed';
            }

            let icon = "iconamoon:eye-off-light";
            this.items.push({
              label: element.title,
              icon: icon,
              link: link,
              state: currentState,
              isPremium: element.isPremium
            });
          }
        }
      },
    },
  },
};
</script>
